module.exports = function (app) {
    app.
        controller('pages.ndregistration.createLogin', ['$scope', '$filter', '$timeout', 'sessionData', 'services', '$cookies', 'finder-logic2', 'session','$q', 'coremetrics', 'brand','passwordSecurityService','$state',
        function ($scope, $filter, $timeout, sessionData, services, $cookies, finderLogic, session,$q, coremetrics, brand, passwordSecurityService, $state) {

            $scope.securityQuestions = [
                {label: 'In what city were you born?', value: 'In what city were you born?'},
                {label: 'What was the name of your first pet?', value: 'What was the name of your first pet?'},
                {label: 'What is your favorite food?', value: 'What is your favorite food?'},
                {label: 'What was your first car?', value: 'What was your first car?'},
                {label: 'What is your favorite vacation spot?', value: 'What is your favorite vacation spot?'}];

            $scope.memberInfo = session.data.memberInfo;
            $scope.criteria = {};


            $scope.passwordRules = {};


            $scope.clearForm = function() {
                $scope.changePassword.currentPassword = '';
                $scope.changePassword.password = '';
                $scope.changePassword.verifiedPassword = '';
            };
            $scope.clearFields = function() {
                $scope.changeSecurityQuestion.newSecurityQuestion= "";
                $scope.changeSecurityQuestion.newSecurityQuestionAnswer="";

            };

        }
    ])

        .directive('memberPasswordValidatornd', function () {
                       return {
                           restrict: "A",
                           require: "ngModel",
                           scope: {
                               criteria: '=memberPasswordValidatornd'
                           },
                           link: function (scope, element, attrs, ctrl) {
                               scope.criteria = scope.criteria || {};


                               ctrl.$validators.passwordRules = function (modelValue, viewValue) {
                                   var count = 0;
                                   scope.criteria = {};

                                   if (viewValue && viewValue !== undefined) {
                                       if (viewValue.length >= attrs.minlength && viewValue.length <= attrs.maxlength) {
                                           scope.criteria.hasValidLength = true;
                                       }
                                       if (/[0-9]/.test(viewValue)) {
                                           scope.criteria.hasOneNumber = true;
                                           count++;
                                       }
                                       if (/[#!@$%^&*\(\)\-_=+|;:'",<.>?`~\\\/\[\]\{\}]/.test(viewValue)) {
                                           scope.criteria.hasSpecialCharacter = true;
                                           count++;
                                       }
                                       if (viewValue.toLowerCase() !== viewValue) {
                                           scope.criteria.hasUpperCase = true;
                                           count++;
                                       }
                                       if (viewValue.toUpperCase() !== viewValue) {
                                           scope.criteria.hasLowerCase = true;
                                           count++;
                                       }
                                       var trimmedPassword = viewValue.replace(/\s/g, '');
                                       if (trimmedPassword !== viewValue){
                                           scope.criteria.noSpace = false;
                                       }else{scope.criteria.noSpace = true;}

                                       scope.criteria.hasPassed = (count > 2);

                                       return !!scope.criteria.hasPassed;
                                   }
                                   return true;
                               };


                           }
                       };
                   })

};
